/* global axios */

export default {
  getScore(accountId, contactId) {
    return axios.get(`/api/v1/accounts/${accountId}/contacts/${contactId}/score`);
  },

  getSummary(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/contact_scores/summary`);
  },
};
